import React from "react";
import { clsx } from "clsx";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";

import { Locale } from "~types/wardenclyffe";
import { isLanguageCodeJa } from "~utils/i18n/isLanguageCodeJa";

import styles from "./ArticleAbstract.module.css";

interface ArticleAbstractProps {
    abstract?: string[];
    className?: string;
    languageCode?: Locale;
}

export const ArticleAbstract = ({
    abstract,
    className,
    languageCode = Locale.En,
}: ArticleAbstractProps) => {
    if (!abstract || !abstract.length) {
        return null;
    }

    const isJa = isLanguageCodeJa(languageCode);

    return (
        <ul
            className={clsx(className, styles.abstract, {
                [styles.abstractDefaultLocale]: !isJa,
                [typographyStyles.articleBody]: isJa,
            })}
            data-component="abstract"
        >
            {abstract.map((item, index) => (
                <li key={`abstract-item-${index}`}>{item}</li>
            ))}
        </ul>
    );
};
